// extracted by mini-css-extract-plugin
export var banner = "_i6-0";
export var closeButton = "_i6-2";
export var greenCheckmark = "_i6-3";
export var hereLink = "_i6-4";
export var titleIcon = "_i6-1";